import React, { FC } from "react";
import { LoadingAnimation } from "../../../../../LoadingAnimation/LoadingAnimation";

import { useInsuranceLabels } from "../../../../Utils/Context/labelsContext";

import { Button } from "../../../../Partials/Button";
import { Link } from "../../../../Partials/Link";

import { InsuranceFormSubmissionStatus } from "../../../../Utils/types";
import { StreamLineIcon } from "../../../../../SvgIcon/StreamLineIcon";

interface BookingConfirmationControlsProps {
  onCancel: () => void;
  onAccept: () => void;
  status: InsuranceFormSubmissionStatus;
}

export const BookingConfirmationControls: FC<
  BookingConfirmationControlsProps
> = (props) => {
  const { onCancel, onAccept, status } = props;

  const { buttons } = useInsuranceLabels();

  return (
    <div className="bookingConfirmationControls">
      {status === "initial" || status == "loading" ? (
        <>
          <Button
            className="bookingConfirmationControls__discard"
            type="solid"
            size="large"
            tier="secondary"
            onClick={onCancel}
          >
            <span className="insuranceButton__label">
              <StreamLineIcon
                iconName="s-edit"
                className="bookingConfirmationControls__icon"
              />
              <span className="bookingConfirmationControls__label">
                {buttons.backAndEditButtonLabel}
              </span>
            </span>
          </Button>
          <Button
            className="bookingConfirmationControls__submit"
            type="solid"
            size="large"
            tier="tertiary"
            onClick={onAccept}
          >
            <span className="insuranceButton__label">
              <StreamLineIcon
                iconName="s-arrow-right-dash"
                className="bookingConfirmationControls__icon"
              />
              <span className="bookingConfirmationControls__label">
                {buttons.requestBookingButtonLabel}
                <span className="bookingConfirmationControls__loading">
                  {status === "loading" && (
                    <LoadingAnimation className="bookingConfirmationControls__loadingItem" />
                  )}
                </span>
              </span>
            </span>
          </Button>
        </>
      ) : (
        <Link
          href="/"
          type="button"
          buttonType="clear"
          buttonSize="large"
          buttonTier="primary"
        >
          <span className="insuranceButton__label">
            <StreamLineIcon iconName="s-arrow-left-dash" />
            <span>{buttons.goToHomePageButtonLabel}</span>
          </span>
        </Link>
      )}
    </div>
  );
};
